<template>
  <web-component-loader v-if="stage" name="sccs-compare-floating-bar" :environment="stage">
    <div class="compare-float-bar">
      <sccs-compare-floating-bar @compare-products="onCompare" />
    </div>
  </web-component-loader>

  <web-component-loader v-if="stage && vehicles" name="sccs-compare" :environment="stage">
    <wb-modal v-if="isCompareVisible" mode="info" class="compare-full-width" scroll-lock @wbclose="onClose">
      <wb-modal-header />
      <wb-modal-content :headline.attr="props.modalTitle">
        <!-- eslint-disable vue/attribute-hyphenation -->
        <sccs-compare
          .initialVehicleIdentifiers="vehicles"
          disable-vehicle-selection
          show-footnotes
          @critical-error="onError"
        />
        <!-- eslint-enable -->
      </wb-modal-content>
    </wb-modal>
  </web-component-loader>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from 'vue';
import { getAemEnvironmentVariables } from '../../../utils/aem.util';
import { VehicleIdentifiers } from '../types';
import { Logger } from '../../../utils/logger.util';

export default defineComponent({ name: 'CompareStage' });
</script>

<script lang="ts" setup>
const props = defineProps({
  modalTitle: {
    required: true,
    type: String,
  },
});

const vehicles = ref<VehicleIdentifiers | null>(null);
const stage = ref();
const isCompareVisible = ref(false);

const onCompare = ({ detail }: { detail: VehicleIdentifiers }) => {
  vehicles.value = detail;
  isCompareVisible.value = true;
};

const onError = (error) => {
  Logger.error('CompareStage::onError()', error);
};

const onClose = () => {
  isCompareVisible.value = false;
};

onBeforeMount(async () => {
  const aemEnv = await getAemEnvironmentVariables();

  stage.value = aemEnv.stage;
});
</script>

<style lang="scss">
.compare-float-bar {
  position: fixed;
  pointer-events: none;
  z-index: 33;

  @include breakpoint-from(mq4) {
    width: 100%;
    display: flex;
    justify-content: center;
    bottom: 50px;
    z-index: 32;
  }

  > * {
    pointer-events: all;
  }
}

.compare-full-width {
  width: 100%;

  & .wb-modal__outer {
    max-width: 100% !important;
    width: 100% !important;
    max-height: 100% !important;
    height: 100% !important;

    & .wb-modal__inner {
      width: auto !important;
      margin: auto !important;
    }
  }
}
</style>
